import { useEffect, useState } from 'react';

/**
 * Top-of-page banner shown when the browser reports `navigator.onLine === false`.
 * Sticky, doesn't push content — relies on `position: fixed`.
 */
export function OfflineBanner() {
  const [online, setOnline] = useState(typeof navigator !== 'undefined' ? navigator.onLine : true);

  useEffect(() => {
    const goOnline = () => setOnline(true);
    const goOffline = () => setOnline(false);
    window.addEventListener('online', goOnline);
    window.addEventListener('offline', goOffline);
    return () => {
      window.removeEventListener('online', goOnline);
      window.removeEventListener('offline', goOffline);
    };
  }, []);

  if (online) return null;

  return (
    <output
      className="fixed top-0 left-0 right-0 z-50 bg-warn-text text-white font-hand text-[14px] py-1.5 px-3 flex items-center justify-center gap-2"
      data-testid="offline-banner"
    >
      <span aria-hidden>📡</span>
      <span>Hors-ligne — l'édition manuelle reste disponible.</span>
    </output>
  );
}
